import { useState } from "react";
import { Link } from "react-router-dom";
import Paginator from "../../Pagination/Pagination.component";
import { Loader } from "../../../UI/Loaders/Loaders";
import usePendingInvestmentProducts from "../../../custom-hooks/usePendingInvestmentProducts";
import CustomSelectDropdown from "../../../NewComponents/TypedComponents/CustomHTMLElements/CustomSelectDropdown";
import useMifosProduct from "../../../custom-hooks/useMifosProduct";

export default function InvestmentProductRequest() {
  // const [searchString, setSearchString] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [size, setSize] = useState(20);
  const [searchValue, setSearchValue] = useState("");

  const { data, status, error } = usePendingInvestmentProducts();
  const {
    data: mifosData,
    // status: mifosStatus,
    // error: mifosError,
  } = useMifosProduct({ productType: 3 });

  let RenderedComponent = null;
  if (!data && status !== "loading") {
    RenderedComponent = (
      <div>
        <div className="grid__padding animated fadeInRight">
          <h4 className="center-txt">
            <i className="fas fa-bell" /> Unable to Fetch Investment Fund
            Activation Requests
          </h4>
        </div>
      </div>
    );
  } else if (status === "loading") {
    RenderedComponent = (
      <Loader
        centered={true}
        text="Loading pending investment fund requests..."
      />
    );
  } else {
    if (error) {
      RenderedComponent = (
        <div>
          <div className="grid__padding animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> There was an issue while fetching
              pending investment fund requests, Please Reload The Page{" "}
            </h4>
          </div>
        </div>
      );
    } else if ((data && data.length === 0) || !data) {
      RenderedComponent = (
        <div className="centerLoader">
          <div className="grid__padding animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> There are currently no pending
              investment fund requests.
            </h4>
          </div>
        </div>
      );
    } else {
      RenderedComponent = (
        <div className="row m-x-sm m-y-2 grid__padding">
          <div className="table-responsive">
            <table className="table">
              <thead className="bg-lighter-grey">
                <tr>
                  <th>S/N</th>
                  <th>Reference</th>
                  <th>Name</th>
                  <th>Created Date</th>
                  <th>Comment</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {data &&
                  data
                    .filter(
                      (eachData: any) =>
                        (eachData.name &&
                          eachData.name
                            .toLowerCase()
                            .includes(searchValue.toLowerCase())) ||
                        (eachData.reference &&
                          eachData.reference
                            .toLowerCase()
                            .includes(searchValue.toLowerCase())) ||
                        (eachData.pubDate &&
                          eachData.pubDate
                            .toLowerCase()
                            .includes(searchValue.toLowerCase())) ||
                        (eachData.startDate &&
                          eachData.startDate
                            .toString()
                            .toLowerCase()
                            .includes(searchValue.toString().toLowerCase())) ||
                        (eachData.endDate &&
                          eachData.endDate
                            .toLowerCase()
                            .includes(searchValue.toLowerCase()))
                    )
                    .slice(
                      (pageNumber - 1) * size,
                      size * (pageNumber - 1) + size
                    )
                    .map((request: any, _id: number) => {
                      const {
                        reference,
                        name,
                        pubDate,
                        comment,
                        user_id,
                        startDate,
                        endDate,
                      } = request;
                      return (
                        <tr key={_id}>
                          <td>{(pageNumber - 1) * size + (_id + 1)}</td>
                          <td>{reference}</td>
                          <td>{name}</td>
                          <td>{pubDate?.substring(0, 10)}</td>
                          <td>{comment}</td>
                          <td>{startDate?.substring(0, 10)}</td>
                          <td>{endDate?.substring(0, 10)}</td>
                          <td>
                            <Link
                              to={{
                                pathname: `/approval-requests/${user_id}/investment`,
                                state: {
                                  data: request,
                                  mifosData: mifosData,
                                },
                              }}
                              className="color-blue"
                            >
                              Review Request
                            </Link>
                          </td>
                        </tr>
                      );
                    })}
              </tbody>
            </table>
          </div>
        </div>
      );
    }
  }
  return (
    <div>
      <div className="d-flex align-items-center justify-content-between mb-3">
        <div>
          {status === "success" && (
            <span>
              You have{" "}
              <span className="font-weight-bold">
                {data?.length ? data?.length : "No"} pending
              </span>{" "}
              requests
            </span>
          )}
        </div>
        <div className="d-flex flex-wrap justify-content-end align-items-center">
          <div className="input-group mr-3 mt-3" style={{ maxWidth: "200px" }}>
            <input
              type="search"
              className="form-control"
              placeholder="Search..."
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
            />
          </div>
          <div style={{ width: "150px", marginTop: "10px" }}>
            <CustomSelectDropdown
              onChange={(e: any) => {
                setSize(e.target.value);
              }}
              value={size}
            >
              <option value={10000}>All</option>
              <option value={10}>10 Entries</option>
              <option value={20}>20 Entries</option>
              <option value={50}>50 Entries</option>
              <option value={100}>100 Entries</option>
            </CustomSelectDropdown>
          </div>
        </div>
      </div>
      {/*Datatable || Loader || Error Message*/}
      {RenderedComponent}

      <Paginator
        size={size}
        page={pageNumber}
        count={data ? data.length : 0}
        changeCurrentPage={(pageNumber: number) => setPageNumber(pageNumber)}
      />
    </div>
  );
}
